<template>
    <div class="col-12 mt-3">
        <div class="row">
            <div class="col-md-1 col-6 Pointer d-none d-md-block"></div>

            <!-- آب -->
            <div class="col-md-2 col-4 Pointer mt-1" :id="'Ghabz'+0" @click="selectMenu(0)">
                <div class="cardGhabz cardGhabz_Water">
                    <img src="../../../public/Template/NewMenu/img/Ghabz/faucet.png" width="32%" class="my-4"/>
                    <div class="font-weight-bold my-2 Water-color">قبض آب</div>
                </div>
            </div>
            <!-- برق -->
            <div class="col-md-2 col-4 Pointer mt-1" :id="'Ghabz'+1" @click="selectMenu(1)">
                <div class="cardGhabz cardGhabz_Electricity">
                    <img src="../../../public/Template/NewMenu/img/Ghabz/lightbulb-on.png" width="32%" class="my-4"/>
                    <div class="font-weight-bold my-2 Electricity-color">قبض برق</div>
                </div>
            </div>
            <!-- گاز -->
            <div class="col-md-2 col-4 Pointer mt-1" :id="'Ghabz'+2" @click="selectMenu(2)">
                <div class="cardGhabz cardGhabz_Gas">
                    <img src="../../../public/Template/NewMenu/img/Ghabz/fire-burner.png" width="32%" class="my-4"/>
                    <div class="font-weight-bold my-2 Gas-color">قبض گاز</div>
                </div>
            </div>
            <!-- موبایل -->
            <div class="col-md-2 col-4 Pointer mt-1" :id="'Ghabz'+3" @click="selectMenu(3)">
                <div class="cardGhabz cardGhabz_Mobile">
                    <img src="../../../public/Template/NewMenu/img/Ghabz/sim-cards.png" width="32%" class="my-4"/>
                    <div class="font-weight-bold my-2 Mobile-color">قبض تلفن همراه</div>
                </div>
            </div>
            <!-- ثابت -->
            <div class="col-md-2 col-4 Pointer mt-1" :id="'Ghabz'+4" @click="selectMenu(4)">
                <div class="cardGhabz cardGhabz_FixedLine">
                    <img src="../../../public/Template/NewMenu/img/Ghabz/phone-office.png" width="32%" class="my-4"/>
                    <div class="font-weight-bold my-2 FixedLine-color">قبض تلفن ثابت</div>
                </div>
            </div>
            
            <div class="col-md-1 col-6 Pointer d-none d-md-block"></div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
        }
    },
    methods:{
        selectMenu(indexMenu){
           let SelectElement= document.getElementById('Ghabz'+indexMenu)
           let AllElement= document.getElementsByClassName('cardGhabz');
           AllElement.forEach(element => {
            element.classList.remove('Active0');
            element.classList.remove('Active1');
            element.classList.remove('Active2');
            element.classList.remove('Active3');
            element.classList.remove('Active4');
          });
            SelectElement.childNodes[0].classList.add('Active'+indexMenu);
           this.$emit('indexSelected',indexMenu)
        },
    },
    props:['indexActive'],
    mounted(){
        this.selectMenu(this.indexActive)
    }

}
</script>
<style scoped>
.cardGhabz_Water{
    width: 100%;
    border-radius: 8px;
    border: dashed 1px #77bcfc;
    padding: 2%;
    background: #fff;
    text-align: center;
    transition: 0.5s;
}
.cardGhabz_Water:hover{
    transition: 0.5s;
    -webkit-box-shadow: 0px 0px 68px -30px rgba(0,77,87,1);
    -moz-box-shadow: 0px 0px 68px -30px rgba(0,77,87,1);
    box-shadow: 0px 0px 68px -30px rgba(0,77,87,1);
}
.Water-color{
    color: #2989DE;
}

.cardGhabz_Gas{
    border: dashed 1px #C74305;
}
.cardGhabz_Gas:hover{
    transition: 0.5s;
    -webkit-box-shadow: 0px 0px 68px -30px rgba(199,67,5,1);
    -moz-box-shadow: 0px 0px 68px -30px rgba(199,67,5,1);
    box-shadow: 0px 0px 68px -30px rgba(199,67,5,1);
}
.Gas-color{
    color: #C74305;
}

.cardGhabz_Electricity{
    border: dashed 1px #D4C305;
}
.cardGhabz_Electricity:hover{
    transition: 0.5s;
    -webkit-box-shadow: 0px 0px 68px -30px rgba(212,195,5,1);
    -moz-box-shadow: 0px 0px 68px -30px rgba(212,195,5,1);
    box-shadow: 0px 0px 68px -30px rgba(212,195,5,1);
}
.Electricity-color{
    color: #D4C305;
}

.cardGhabz_FixedLine{
    border: dashed 1px #767676;
}
.cardGhabz_FixedLine:hover{
    transition: 0.5s;
    -webkit-box-shadow: 0px 0px 68px -30px rgba(118,118,118,1);
    -moz-box-shadow: 0px 0px 68px -30px rgba(118,118,118,1);
    box-shadow: 0px 0px 68px -30px rgba(118,118,118,1);
}
.FixedLine-color{
    color: #767676;
}


.cardGhabz_Mobile{
    border: dashed 1px #3400A3;
}
.cardGhabz_Mobile:hover{
    transition: 0.5s;
    -webkit-box-shadow: 0px 0px 68px -30px rgba(52,0,163,1);
    -moz-box-shadow: 0px 0px 68px -30px rgba(52,0,163,1);
    box-shadow: 0px 0px 68px -30px rgba(52,0,163,1);
}
.Mobile-color{
    color: #3400A3;
}



.cardGhabz img{
    transition: 0.5s;
}
.cardGhabz:hover img{
    transform: scale(1.3);
    transition: 0.5s;
}
.cardGhabz{
    width: 100%;
    border-radius: 8px;
    padding: 2%;
    background: #fff;
    text-align: center;
    transition: 0.5s;
}
.cardGhabz .font-weight-bold{
    font-size: 13px;
}
.Active0{
    background: #a4ebf030;
}
.Active1{
    background: #D4C30530;
}
.Active2{
    background: #C7430520;
}
.Active3{
    background: #3400A320;
}
.Active4{
    background: #76767630;
}

</style>